import { render, staticRenderFns } from "./TaskTemplateDetailEditForm.vue?vue&type=template&id=85dc4dae&"
import script from "./TaskTemplateDetailEditForm.vue?vue&type=script&lang=js&"
export * from "./TaskTemplateDetailEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports